define('app/models/gift_message_form',['app/setup'], function(takhfifan) {
  takhfifan.giftMessageForm = Backbone.Model.extend({

    validation: {
      'giftmessageFrom': {
          required: true,
          msg: i18n.t('required')
      },
      'giftmessageTo': {
          required: true,
          msg: i18n.t('required')
      },
      'giftmessageMessage': {
          required: true,
          msg: i18n.t('required')
      }
    }
  });
});

